<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Réinitialisez votre mot de passe</h1>

        <div
          class="alert alert-danger"
          role="alert"
          v-bind:class="{ hide: status.login.errorMessage == null }"
        >{{status.login.errorMessage}}</div>

        <form @submit.prevent="reset">
          <div class="control-group">
            <div class="form-group floating-label-form-group controls mb-0 pb-2">
              <label>Nouveau mot de passe</label>
              <input type="password" class="form-control" v-model="loginForm.newpassword" placeholder="Nouveau Mot de passe" />
            </div>
          </div>

          <br />
          <div class="form-group">
            <button
              type="submit"
              class="btn btn-primary btn-xl"
              v-bind:class="{ hide: status.login.loading == true || status.login.done == true }"
            >Réinitialiser votre mot de passe</button>

            <div
              class="spinner-border text-primary"
              role="status"
              v-bind:class="{ hide: status.login.loading == false }"
            >
              <span class="sr-only">Demande de réinitialisation en cours...</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "UserReset",
  getterMethods: null,
  data() {
    return {
      loginForm: { email: "", newPassword: "", resetToken: "" },
      errorLogin: {},
      status: {
        login: { loading: false, errorMessage: null, done: false }
      }
    };
  },
  mounted() {
    this.loginForm.email = this.$route.params.email;
    this.loginForm.resetToken = this.$route.params.resetToken;
  },
  methods: {
    reset: function() {
      var vm = this;
      console.log(this.loginForm);
      vm.status.login.loading = true;
      vm.status.login.errorMessage = null;

      axios
        .put(process.env.BACKEND_URL + "/api/users/password/reset", vm.loginForm)
        .then(response => {
          vm.status.login.loading = false;
          vm.status.login.done = true;

          if (response.status == 200) {
            vm.$store.dispatch("logUser", response.data.token);

            vm.$router.push("/search");
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status == 411)
              vm.status.login.errorMessage =
                "Le mot de passe doit comporter au minimum 6 caractères et au moins 2 des critères suivants : une lettre minuscule, une lettre majuscule, un chiffre, un caractère spéciale";
            if (error.response.status == 500)
              vm.status.login.errorMessage =
                "Erreur serveur : <br /><i>" +
                JSON.stringify(error.response.data) +
                "</i>";
          } else
            vm.status.login.errorMessage =
              "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.login.loading = false;
        });

      return false;
    },
  }
};
</script>

<style scope>
.container {
  padding-top: 40px;
}

a.search-list-item {
  display: block;
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/users/UserReset.vue